let GlobalMask = xClass("GlobalMask", cc.Layer)

const WAIT_TIME = 3;    // 3S后出现动画

let _instance = null;
let _showCount = 0;
let tagMap = {};

GlobalMask.Active = function (tag) {
    if (_instance == null) {
        _instance = new GlobalMask(tag);
        _instance.retain();
    }

    let runningScene = cc.Director.getInstance().getRunningScene();
    if (runningScene != _instance.parent) {
        _instance.removeFromParent();
        runningScene.addChild(_instance);
    }

    if (tag != null) {
        if (tagMap.hasOwnProperty(tag))
            tagMap[tag]++;
        else
            tagMap[tag] = 1;
    }

    _showCount++;
    
    console.log("GlobalMask.Active", tag, _showCount);
}

GlobalMask.Unactive = function (tag) {
    let countDown = 1;
    if (tag != null) {
        if(tagMap.hasOwnProperty(tag)) {
            countDown = tagMap[tag];
            tagMap[tag] = 0;
        } else 
            countDown = 0; 
    }

    _showCount = _showCount - countDown;
    console.log("GlobalMask.Unactive", tag, _showCount);
    if (_showCount <= 0) {
        _showCount = 0;

        if (_instance != null && _instance.parent != null) {
            _instance.removeFromParent();
        }
    }
}

GlobalMask.prototype.ctor = function (tag) {
    cc.Layer.prototype.ctor.call(this);
    
    this.countAnimaion = null;

    let listener = cc.EventListenerTouchOneByOne.create();
    listener.setSwallowTouches(true);
    listener.registerScriptHandler(
        () => { 
            cc.log("GlobalMask============tag ",tag)
            return true 
        },
        cc.Handler.EVENT_TOUCH_BEGAN
    );
    this.listener = listener;
    this.listener.retain();
}

GlobalMask.prototype.onEnter = function() {
    cc.Layer.prototype.onEnter.call(this);
    this.setGlobalZOrder(1);
    if (this.countAnimaion != null)
        this.countAnimaion.setVisible(false);

    this.scheduleOnce(()=>this.showAnimation(), WAIT_TIME);    
    cc.eventManager.addListener(this.listener, this);    
}

GlobalMask.prototype.onExit = function() {
    if (this.countAnimaion != null) {
        this.countAnimaion.removeFromParent(true);
        this.countAnimaion = null;
    }
    this.unscheduleAllCallbacks();
    cc.eventManager.removeListener(this.listener, this);

    cc.Layer.prototype.onExit.call(this);       
    
    _showCount = 0;
}

GlobalMask.prototype.showAnimation = function () {
    if (this.countAnimaion == null) {
        this.countAnimaion = CountDownAnimation.createLoadingAnimation(getText("panel.text.now.load"));
        this.countAnimaion.setPosition(display.center.x, display.center.y)
        this.addChild(this.countAnimaion);
    }
    this.countAnimaion.setVisible(true);
}

module.exports = GlobalMask